// src/Pages/Ride.js
import React from "react";
import { Link } from "react-router-dom";
import { products } from "../data/carsData";

function Ride() {
  return (
    <div className="container mx-auto py-10 px-4">
      {/* Page Header */}
      <div className="text-center mb-10">
        <h1 className="text-4xl font-extrabold text-gray-900">🚖 Book a Ride</h1>
        <p className="mt-3 text-gray-600 max-w-2xl mx-auto">
          Need a quick trip across the city? Choose from our available rides and
          get there fast, safe, and comfortable.
        </p>
      </div>

      {/* Products Grid */}
      <div className="grid gap-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {products["ride"].map((prod) => (
          <Link
            key={prod.id}
            to={`/product/${prod.id}`}
            state={prod}
            className="group bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl hover:scale-[1.02] transition transform"
          >
            {/* Ride Image */}
            <div className="relative">
              <img
                src={prod.image}
                alt={prod.name}
                className="w-full h-48 object-cover group-hover:opacity-90 transition"
              />
              <span className="absolute top-3 left-3 bg-green-600 text-white text-xs font-medium px-3 py-1 rounded-full shadow">
                Ready
              </span>
            </div>

            {/* Ride Info */}
            <div className="p-5">
              <h3 className="text-lg font-bold text-gray-900 group-hover:text-green-600 transition">
                {prod.name}
              </h3>
              <p className="mt-2 text-sm text-gray-600 line-clamp-2">
                {prod.description || "Fast, reliable, and affordable rides."}
              </p>
              <div className="mt-4 flex justify-between items-center">
                <span className="text-xl font-semibold text-green-600">
                  ${prod?.price ? prod.price : 0}
                </span>
                <span className="text-sm text-gray-500">per ride</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Ride;